<template lang="pug">
	div.accommodations--filter-list
		v-card.mb-6.pb-2(color="info" outlined)
			v-list(nav dense style="background-color:transparent")
				v-subheader.font-weight-bold.body-2(style="height:32px") {{$t('accommodations-filters.heading.destination')}}
				v-autocomplete.ma-1(no-filter outlined solo flat dense hide-details clearable append-icon="" v-model="destination" :placeholder="$t('accommodations-filters.destination.placeholder')" item-text="name" item-value="slug" :items="destinationItems" :search-input.sync="destinationInput")
					template(#item="data")
						v-list-item-avatar(v-if="data.item.countryCode" size="20" tile)
							img.flag.ma-0(:src="`https://static.wintersport.nl/images/flags/svg/${data.item.countryCode}.svg`")
						v-list-item-content {{data.item.name}}
						v-list-item-avatar(size="20")
							ws-icon(small) {{icons[data.item.__typename]}}
				v-subheader.font-weight-bold.body-2(style="height:32px")  {{$t('accommodations-filters.heading.departure')}}
				minimum-filter(:duration="duration" :persons="persons" :date="date" @update="updateMinimum" instant disable-action)
				v-select.ma-1(:label="$tc('accommodations-filters.bedrooms', 0)" outlined solo flat dense hide-details :items="bedroomOptions" v-model.number="bedrooms")
		v-img.mb-6.text-center.py-3(v-if="showMapButton" :src="require('~/assets/images/static-map-large.jpg')")
			v-btn.text-none(v-if="!showMap" color="accent" depressed @click.prevent="showMap = !showMap")
				ws-icon(small left) map-marker
				| {{$t('accommodations-filters.button_show_map')}}
			v-btn.text-none(v-else color="accent" depressed @click.prevent="showMap = !showMap")
				ws-icon(small left) map-marker
				| {{$t('accommodations-filters.button_hide_map')}}
		v-card.mb-6.pb-2(outlined)
			v-toolbar.white--text(color="primary" flat height="30px")
				v-toolbar-title.body-1.font-weight-bold {{$t('accommodations-filters.heading.accommodations')}}
			v-list(nav dense)
				v-list-item-group(v-model="booleanFilters" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.location')}}
					list-checkbox(value="isNearSkilift") {{$t('accommodations-filters.skilift')}}
					list-checkbox(value="isInResort") {{$t('accommodations-filters.resort')}}

				v-list-item-group(v-model="types" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.type')}}
					list-checkbox(value="hotel") {{$t('accommodations-filters.hotel')}}
					list-checkbox(value="chalet") {{$t('accommodations-filters.chalet')}}
					list-checkbox(value="apartment") {{$t('accommodations-filters.apartment')}}
					list-checkbox(value="pension") {{$t('accommodations-filters.pension')}}


				v-list-item-group(v-model="facilities" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.facilities')}}
					list-checkbox(value="wifi") {{$t('accommodations-filters.wifi')}}
					list-checkbox(value="swimming") {{$t('accommodations-filters.swimming')}}
					list-checkbox(value="sauna") {{$t('accommodations-filters.sauna')}}
					list-checkbox(value="hottub") {{$t('accommodations-filters.hottub')}}

		v-card.mb-6.pb-2(outlined)
			v-list(nav dense)
				v-list-item-group(v-model="transporttype" mandatory)
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.transporttype')}}
					list-checkbox(:value="null") Eigen vervoer
					list-checkbox(value="bus") Bus
					list-checkbox(value="airplane") Vliegtuig
					//- list-checkbox(value="train") Trein

				v-list-item-group(v-model="partners" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.partners')}}
					list-checkbox(:value="oldId" v-for="({oldId, name}, index) in visiblePartners" :key="oldId") {{name}}
					v-list-item(v-if="!showAllPartners && $i18n.locale === 'nl-NL'" @click.prevent="showAllPartners = true")
						v-list-item-action.mr-2.my-0
							v-icon keyboard_arrow_down
						v-list-item-content
							v-list-item-title.primary--text {{$t('accommodations-filters.show-all-partners')}}

				v-list-item-group(v-model="booleanFilters" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.onsite')}}
					list-checkbox(value="onsite") {{$t('accommodations-filters.onsite')}}

		v-card.mb-6.pb-2(outlined)
			v-list(nav dense)
				v-list-item-group(v-model="rating")
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.rating')}}
					list-checkbox(:value="9") {{$t('accommodations-filters.rating9')}}
					list-checkbox(:value="8") {{$t('accommodations-filters.rating8')}}
					list-checkbox(:value="7") {{$t('accommodations-filters.rating7')}}
					list-checkbox(:value="6") {{$t('accommodations-filters.rating6')}}

				v-list-item-group(v-model="stars")
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.stars')}}
					list-checkbox(:value="5") {{$t('accommodations-filters.stars5')}}
					list-checkbox(:value="4") {{$t('accommodations-filters.stars4')}}
					list-checkbox(:value="3") {{$t('accommodations-filters.stars3')}}

				v-list-item-group(v-model="servicetype")
					v-subheader.font-weight-bold.body-2 {{$t('accommodations-filters.heading.servicetype')}}
					list-checkbox(value="roomonly") {{$t('accommodations-filters.roomonly')}}
					list-checkbox(value="breakfast") {{$t('accommodations-filters.breakfast')}}
					list-checkbox(value="halfboard") {{$t('accommodations-filters.halfboard')}}

		v-card.mb-6.pb-2(outlined)
			v-toolbar.white--text(color="primary" flat height="30px")
				v-toolbar-title.body-1.font-weight-bold {{$t('areas-filters.heading.areas')}}
			v-list(nav dense)
				v-alert.caption(v-if="hasDestinationFilter" style="cursor:pointer" @click.prevent="clearDestination" dense outlined text type="warning") Je zoekt nu in {{this.destinationInput}}. Klik hier om overal te zoeken.

				v-list-item-group(v-model="sizes" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.area_size')}}
					list-checkbox(value="s" :disabled="hasDestinationFilter") {{$t('areas-filters.small')}}
					list-checkbox(value="m" :disabled="hasDestinationFilter") {{$t('areas-filters.medium')}}
					list-checkbox(value="l" :disabled="hasDestinationFilter") {{$t('areas-filters.large')}}
					list-checkbox(value="xl" :disabled="hasDestinationFilter") {{$t('areas-filters.extralarge')}}

				v-list-item-group(v-model="pistes" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.pistes')}}
					list-checkbox(value="isEasy" :disabled="hasDestinationFilter") {{$t('areas-filters.easy')}}
					list-checkbox(value="isDifficult" :disabled="hasDestinationFilter") {{$t('areas-filters.difficult')}}
					list-checkbox(value="hasConnectedSlopes" :disabled="hasDestinationFilter") {{$t('areas-filters.connectedslopes')}}
					list-checkbox(value="hasNoFlatAreas" :disabled="hasDestinationFilter") {{$t('areas-filters.noflatareas')}}
					list-checkbox(value="hasDownHill" :disabled="hasDestinationFilter") {{$t('areas-filters.downhill')}}

				v-list-item-group(v-model="elevation")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.elevation')}}
					list-checkbox(:value="2000" :disabled="hasDestinationFilter") {{$t('areas-filters.min2000')}}
					list-checkbox(:value="2500" :disabled="hasDestinationFilter") {{$t('areas-filters.min2500')}}
					list-checkbox(:value="3000" :disabled="hasDestinationFilter") {{$t('areas-filters.min3000')}}

				v-list-item-group(v-model="pistes" multiple)
					list-checkbox(value="hasSummerSkiing" :disabled="hasDestinationFilter") {{$t('areas-filters.summerski')}}

				v-list-item-group(v-model="distanceUtrecht" v-if="$i18n.locale === 'nl-NL'")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.distance_city', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
					list-checkbox(:value="700" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_700')}}
					list-checkbox(:value="900" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_900')}}
					list-checkbox(:value="1000" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_1000')}}

				v-list-item-group(v-model="distanceBrussel" v-if="$i18n.locale === 'nl-BE'")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.distance_city', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
					list-checkbox(:value="700" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_700')}}
					list-checkbox(:value="900" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_900')}}
					list-checkbox(:value="1000" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_1000')}}

				v-list-item-group(v-model="distanceHighway")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.distance_highway')}}
					list-checkbox(:value="25" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_highway_25')}}
					list-checkbox(:value="50" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_highway_50')}}
					list-checkbox(:value="100" :disabled="hasDestinationFilter") {{$t('areas-filters.distance_highway_100')}}
		v-card.d-sm-none.pa-3(style="position:fixed; bottom:0px; right:0px; left:0px;")
			v-btn(@click="emitValue" color="primary" depressed block) {{$t('accommodations-filters.apply-filters')}}

</template>

<style lang="sass">
.accommodations--filter-list
	.v-input
		font-size: 13px

.v-list-item--disabled
	.v-list-item__content
		.v-list-item__title
			color: #9e9e9e
</style>

<script>
import gql from 'graphql-tag';
import {
	VListItem,
	VListItemTitle,
	VListItemAction,
	VListItemContent,
	VCheckbox
} from 'vuetify/lib';
import dayjs from 'dayjs';
import MinimumFilter from '@/components/accommodations/minimum-filter.vue';

const {
	encodeFilters,
	decodeFilters
} = require('@dengl/common/utils/filterstrings');

const ListCheckbox = {
	render(createElement) {
		const content = createElement(VListItemContent, [
			createElement(VListItemTitle, this.$slots.default)
		]);

		return createElement(VListItem, {
			style: 'min-height:0',
			attrs: this.$attrs,
			props: { color: 'primary' },
			on: this.$listeners,
			scopedSlots: {
				default: ({ active }) => {
					const checkbox = createElement(
						VListItemAction,
						{ class: 'mr-2 my-0' },
						[
							createElement(VCheckbox, {
								props: {
									inputValue: active,
									trueValue: this.$attrs.value,
									dense: true
								}
							})
						]
					);

					return [checkbox, content];
				}
			}
		});
	}
};

const emptyFilters = {
	distanceUtrecht: null,
	distanceBrussel: null,
	distanceHighway: null,
	types: [],
	sizes: [],
	pistes: [],
	facilities: [],
	servicetype: null,
	stars: null,
	rating: null,
	transporttype: null,
	partners: [],
	showMap: false
};

export default {
	components: {
		ListCheckbox,
		MinimumFilter
	},
	props: {
		value: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			...emptyFilters,
			elevation: null,
			distanceUtrecht: null,
			distanceBrussel: null,
			distanceHighway: null,
			booleanFilters: [],
			date: '2024-02-17',
			persons: 2,
			duration: 7,
			bedrooms: 0,
			areaslugs: [],
			resortslugs: [],
			destination: '',
			destinationItems: [],
			destinationInput: '',
			showAllPartners: false,
			showMap: false,
			icons: {
				Area: 'ski',
				Resort: 'village',
				Cluster: 'ski',
				Organisation: 'organisation',
				Skihall: 'skihall',
				Revolvingslope: 'revolvingslope',
				Dryslope: 'dryslope',
				Carpetslope: 'carpetslope'
			},
			partnerOptions: {
				'nl-NL': [
					{ oldId: 23, name: 'Belvilla' },
					{ oldId: 54, name: 'Booking.com' },
					{ oldId: 39, name: 'Chalet.nl' },
					{ oldId: 6, name: 'ChaletsPlus' },
					{ oldId: 26, name: 'Interhome' },
					{ oldId: 19, name: 'Landal' },
					{ oldId: 116, name: 'Novasol' },
					{ oldId: 31, name: 'Sportiek' },
					{ oldId: 28, name: 'Summit travel' },
					{ oldId: 11, name: 'Sunweb' },
					{ oldId: 33, name: 'Top-Chalets' },
					{ oldId: 120, name: 'Villa for You' },
					{ oldId: 44, name: 'SnowTrex' }
				],
				'nl-BE': [
					{ oldId: 23, name: 'Belvilla' },
					{ oldId: 54, name: 'Booking.com' },
					{ oldId: 39, name: 'Chalet.be' },
					{ oldId: 26, name: 'Interhome' },
					{ oldId: 116, name: 'Novasol' },
					{ oldId: 31, name: 'Sportiek' },
					{ oldId: 28, name: 'Summit travel' },
					{ oldId: 11, name: 'Sunweb' },
					{ oldId: 44, name: 'SnowTrex' }
				]
			}
		};
	},
	computed: {
		visiblePartners() {
			return this.partnerOptions[this.$i18n.locale].filter((partner, index) => {
				return (
					index < 3 ||
					this.showAllPartners ||
					this.partners.includes(partner.oldId) ||
					this.partnerOptions[this.$i18n.locale].length < 5
				);
			});
		},
		hasDestinationFilter() {
			return !!(
				(this.filters.areaslugs && this.filters.areaslugs.length) ||
				(this.filters.resortslugs && this.filters.resortslugs.length)
			);
		},
		filters() {
			return {
				types: this.types,
				facilities: this.facilities,
				persons: this.persons,
				elevation: this.elevation,
				distanceUtrecht: this.distanceUtrecht,
				distanceBrussel: this.distanceBrussel,
				distanceHighway: this.distanceHighway,
				duration: this.duration,
				date: this.date,
				sizes: this.sizes,
				pistes: this.pistes,
				bedrooms: this.bedrooms,
				servicetype: this.servicetype,
				rating: this.rating,
				stars: this.stars,
				transporttype: this.transporttype,
				partners: this.partners,
				showMap: this.showMap,
				areaslugs:
					this.destination && this.destination.startsWith('Area')
						? [this.destination.replace('Area', '')]
						: null,
				resortslugs:
					this.destination && this.destination.startsWith('Resort')
						? [this.destination.replace('Resort', '')]
						: null,
				regions:
					this.destination && this.destination.startsWith('Region')
						? [this.destination.replace('Region', '')]
						: null,
				countries:
					this.destination && this.destination.startsWith('Country')
						? [this.destination.replace('Country', '')]
						: null,
				...this.booleanFilters.reduce((carry, field) => {
					carry[field] = true;
					return carry;
				}, {})
			};
		},
		filterstring() {
			return encodeFilters(this.filters, this.$i18n.locale);
		},
		bedroomOptions() {
			return [...Array(6).keys()].map((value, index, array) => {
				return {
					text: this.$tc(
						'accommodations-filters.bedrooms',
						index,
						array.length === value + 1 ? { count: `${value}+` } : null
					),
					value: index
				};
			});
		},
		showMapButton() {
			return this.hasDestinationFilter;
		}
	},
	watch: {
		filterstring: {
			deep: true,
			handler(val) {
				if (this.$vuetify.breakpoint.smAndUp) {
					this.$emit('input', val);
				}
			}
		},
		value(val) {
			this.decodeValue(val);
		},
		destinationInput(val) {
			if (!val) return;
			this.searchDestinations(val);
		},
		hasDestinationFilter(val) {
			if (!val) {
				this.showMap = false;
			}
		},
		destination(val) {
			if (val && !this.destinationInput) {
				this.searchDestinations(
					val.replace(/^(Area|Resort|Region|Country)/, '')
				);
			}
		},
		'$store.state.showNavigationDrawer': {
			handler(val) {
				if (!val) {
					this.emitValue();
				}
			}
		}
	},
	created() {
		const minimumFiltersFromStorage = localStorage.getItem('minimumFilters');
		if (minimumFiltersFromStorage) {
			const filtersFromStorage = JSON.parse(minimumFiltersFromStorage);
			if (
				filtersFromStorage.date &&
				dayjs().isBefore(dayjs(filtersFromStorage.date, 'YYYY-MM-DD'))
			)
				this.date = filtersFromStorage.date;
			if (filtersFromStorage.duration)
				this.duration = filtersFromStorage.duration;
			if (filtersFromStorage.persons) this.persons = filtersFromStorage.persons;
		}

		this.decodeValue(this.value);
	},
	methods: {
		emitValue() {
			this.$emit('input', this.filterstring);
		},
		searchDestinations(val) {
			const searchQuery = gql`
				query search($val: String!, $types: [String]!, $limit: Int!) {
					search(term: $val, types: $types, limit: $limit) {
						__typename
						... on Country {
							id
							name
							slug
							countryCode
						}
						... on Region {
							id
							name
							slug
							country {
								id
								countryCode
							}
						}
						... on Area {
							id
							name
							slug
							country {
								id
								countryCode
							}
						}
						... on Resort {
							id
							name
							slug
							country {
								id
								countryCode
							}
						}
					}
				}
			`;

			this.$graphClient
				.query({
					query: searchQuery,
					variables: {
						val,
						types: ['countries', 'regions', 'areas', 'resorts'],
						limit: 8
					}
				})
				.then(({ data }) => {
					this.destinationItems = data.search.map(destination => {
						return {
							...destination,
							name: destination.name,
							countryCode: ['Region', 'Area', 'Resort'].includes(
								destination.__typename
							)
								? destination.country.countryCode
								: destination.countryCode,
							slug:
								destination.__typename +
								(destination.__typename === 'Country'
									? destination.countryCode
									: destination.slug)
						};
					});
				})
				.catch(_err => {});
		},
		clearDestination() {
			this.destination = '';
		},
		extractSingleDestination(filters) {
			// this function is we always only have one destination(most specific)
			this.destination = '';
			if (filters.countries) {
				this.destination = 'Country' + filters.countries[0];
			}
			if (filters.regions) {
				this.destination = 'Region' + filters.regions[0];
			}
			if (filters.areaslugs) {
				this.destination = 'Area' + filters.areaslugs[0];
			}
			if (filters.resortslugs) {
				this.destination = 'Resort' + filters.resortslugs[0];
			}
			filters.areaslugs =
				filters.resortslugs =
				filters.regionslugs =
				filters.countries =
					null;

			return filters;
		},
		decodeValue(val) {
			let filters = {
				...emptyFilters,
				...decodeFilters(val, this.$i18n.locale)
			};
			filters = this.extractSingleDestination(filters);
			this.booleanFilters = [];
			for (const [filter, value] of Object.entries(filters)) {
				if (value === true && filter !== 'showMap') {
					this.booleanFilters.push(filter);
				} else {
					this[filter] = value;
				}
			}
		},
		updateMinimum(filters) {
			for (const [filter, value] of Object.entries(filters)) {
				this[filter] = value;
			}
		}
	}
};
</script>
